import React, { useState } from "react";

// Every experience and certification logo is the CMS's own picture, at the
// address the engine sends. When the CMS has no picture for it, or it fails
// to load, the name is written in its place: a missing logo must never leave
// a gap or a broken image where the customer expects to read what they are
// watching in.
function LogoOrName({ src, name, className, alt }) {
  const [failedSrc, setFailedSrc] = useState(null);

  if (!src || failedSrc === src) {
    return name ? <span className={`logo-name ${className || ""}`.trim()}>{name}</span> : null;
  }
  return <img className={className} src={src} alt={alt || name || ""} onError={() => setFailedSrc(src)} />;
}

export function ExperienceLogo({ src, name, className }) {
  return <LogoOrName src={src} name={name} className={className} />;
}

// Shown only when the booking or show carries a certification. The Arabic
// name is used on the Arabic site when the engine sends one.
export function CertificationLogo({ src, name, nameAlt, className }) {
  if (!name) {
    return null;
  }
  const arabic = localStorage.getItem("language") === "ar";
  return <LogoOrName src={src} name={arabic && nameAlt ? nameAlt : name} className={className} />;
}

// The experience as words, for the places that write it rather than draw it.
export function experienceWithCertification(experience, certification, certificationAlt) {
  if (!certification) {
    return experience || "";
  }
  const arabic = localStorage.getItem("language") === "ar";
  const cert = arabic && certificationAlt ? certificationAlt : certification;
  return experience ? `${experience} · ${cert}` : cert;
}
